export function ReceiveControlBoxViewConstructor(services, callbacks, context, siteTypeConfig) {

  let joint = services.joint;

  return joint.shapes.html.AbstractBoxElementView.extend({

    template: `
<div class="html-element receive-control-box">
  <div class="receive-control-box-content-measurer">
    <div class="question-text-content-container">
      <div class="get-started-content">
        <div class="entrypoint-description-label"></div>
        <div class="entrypoint-description"></div>
      </div>
      <div class="question-edit-container"><span class="glyphicon glyphicon-pencil question-edit"></span></div>
    </div>
    <div class="question-text-content-container">
      <a hidden href="" target="_blank" class="receive-control-box-link"></a>
      <div class="receive-control-box-text"></div>
      <div class="receive-control-edit-container"><span class="glyphicon glyphicon-question-sign receive-control-edit"></span></div>
    </div>
  </div>
</div>
`,

    titleOfEditionPopin: null,
    metadataInputLabel: null,

    initialize: function () {
      this.model.set("canBeTested", false);

      joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);

      // this.$box is initialized by the abstract superclass
      this.$box.find('.receive-control-edit').on('click', () => this.showInformationPopin());
      this.$box.find('.question-edit').on('click', () => this.editBox());

      switch (this.model.get('type')) {
        case 'html.ReceiveControlBox':
          this.titleOfEditionPopin = services.$translate.instant('parameters/quick_replies/details/edit_receive_control/title');
          this.metadataInputLabel = services.$translate.instant('parameters/quick_replies/details/edit_receive_control/thread_control_metadata');
          break;
        case 'html.MessengerMDotMeLinkBox':
          this.titleOfEditionPopin = services.$translate.instant('parameters/quick_replies/details/edit_m_dot_me/title');
          this.metadataInputLabel = "https://messenger.com/t/" + context.site.authorized_user.external_id + "?ref=";
          break;
        case 'html.ExternalEndpointEntryPointBox':
          this.titleOfEditionPopin = services.$translate.instant('parameters/quick_replies/details/edit_external_endpoint/title');
          this.metadataInputLabel = services.$translate.instant('parameters/quick_replies/details/edit_external_endpoint/thread_control_metadata');
          break;
        case 'html.LinkWithRefEntryPointBox':
          this.titleOfEditionPopin = services.$translate.instant('parameters/quick_replies/details/edit_link_with_ref/title');
          this.metadataInputLabel = services.$translate.instant('parameters/quick_replies/details/edit_link_with_ref/thread_control_metadata');
          break;
      }
    },

    updateBox: function () {
      if (this.paper) {
        let text = this.metadataInputLabel + ': ' + this.model.get('thread_control_metadata');
        this.$box.find('.receive-control-box-text').text(text);

        if (this.model.get('type') === 'html.MessengerMDotMeLinkBox') {               // In case of an m.me box the whole url is specified and is made clickable
          text = this.metadataInputLabel + this.model.get('thread_control_metadata');

          this.$box.find('.receive-control-box-text').attr("hidden", "true");
          this.$box.find('.receive-control-box-link').text(text).attr("href", text)
            .css({
              "display": "block",
              "cursor": "pointer",
              "pointer-events": "auto"
            })
            .removeAttr("hidden");
        }
        this.$box.find('.entrypoint-description').text(this.model.get('entrypoint_description'));
      }
      joint.shapes.html.AbstractBoxElementView.prototype.updateBox.apply(this, arguments);
    },

    editGetStartedBox: function () {
      services.$mdDialog.show({
        controller: 'editGetStartedBoxController',
        template: require('./editGetStartedBox.modal.html'),
        locals: {
          entrypointDescription: this.model.get('entrypoint_description'),
          welcomeMessage: null,
          hasWelcomeMessage: false,
          hasComposerInputDisabled: false,
          composerInputDisabled: false
        }
      }).then(res => {
        this.model.set('entrypoint_description', res.entrypointDescription);
        this.updateBox();
        this.resizeBox();
        callbacks.updateSerializedGraph(this.model.graph);
      });
    },

    heightOfHTMLContent: function () {
      return this.$box.find('.receive-control-box-content-measurer').outerHeight();
    },


    /**
     * Event handler that shows a modal showing the postback payload.
     */
    showInformationPopin: function () {
      let modalInstance = services.$uibModal.open({
        animation: true,
        template: require('./receiveControl.modal.html'),
        controller: 'receiveControlModalController',
        resolve: {
          controllerParams: {
            thread_control_metadata: this.model.get('thread_control_metadata'),
            titleOfEditionPopin: this.titleOfEditionPopin,
            metadataInputLabel: this.metadataInputLabel,
          },
          siteId: context.site.id,
          companyId: context.companyId,
        }
      });
    },

  });
}